import { render, staticRenderFns } from "./PublicationsSection.vue?vue&type=template&id=55c31233&scoped=true&"
import script from "./PublicationsSection.vue?vue&type=script&lang=js&"
export * from "./PublicationsSection.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsSection.vue?vue&type=style&index=0&id=55c31233&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c31233",
  null
  
)

export default component.exports